import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
export function RevelationSection() {
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-353">
      <div className="max-w-3xl mx-auto" data-id="element-354">
        <FadeInSection data-id="element-355">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-green-700 mb-10" data-id="element-356">
            Pero hoy quiero revelarte la verdad que lo cambia todo...
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-357">
            <p className="font-bold text-2xl text-center mb-8" data-id="element-358">
              NO es tu culpa. No te falta fuerza de voluntad.
            </p>
            <p data-id="element-359">
              Lo que estás experimentando no es debilidad. Es una respuesta
              biológica normal a una montaña rusa de glucosa.
            </p>
            <p data-id="element-360">
              Cuando comes ciertos alimentos en el orden equivocado, tu azúcar
              en sangre se dispara hacia las nubes.
            </p>
          </div>

          <div className="my-10 bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-361">
            <p className="text-center text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-362">
              Tu azúcar en sangre sin control
            </p>
            <svg viewBox="0 0 600 200" className="w-full h-auto" preserveAspectRatio="xMidYMid meet" data-id="element-363">
              <line x1="50" y1="40" x2="570" y2="40" stroke="#e5e7eb" strokeWidth="1" strokeDasharray="4" data-id="element-364" />
              <line x1="50" y1="100" x2="570" y2="100" stroke="#e5e7eb" strokeWidth="1" strokeDasharray="4" data-id="element-365" />
              <line x1="50" y1="160" x2="570" y2="160" stroke="#e5e7eb" strokeWidth="1" strokeDasharray="4" data-id="element-366" />

              <text x="20" y="44" fontSize="10" fill="#9ca3af" textAnchor="middle" data-id="element-367">
                Alto
              </text>
              <text x="25" y="104" fontSize="10" fill="#9ca3af" textAnchor="middle" data-id="element-368">
                Normal
              </text>
              <text x="20" y="164" fontSize="10" fill="#9ca3af" textAnchor="middle" data-id="element-369">
                Bajo
              </text>

              <path d="M60,100 Q100,100 140,35 Q170,10 200,35 Q230,100 260,155 Q280,170 310,155 Q330,100 370,35 Q400,10 430,35 Q460,100 490,155 Q510,170 540,155 L560,140" fill="none" stroke="#ef4444" strokeWidth="3" strokeLinecap="round" data-id="element-370" />

              <text x="185" y="22" fontSize="11" fill="#ef4444" fontWeight="bold" textAnchor="middle" data-id="element-371">
                ⬆ Pico
              </text>
              <text x="275" y="185" fontSize="11" fill="#ef4444" fontWeight="bold" textAnchor="middle" data-id="element-372">
                ⬇ Caída
              </text>
              <text x="385" y="22" fontSize="11" fill="#ef4444" fontWeight="bold" textAnchor="middle" data-id="element-373">
                ⬆ Pico
              </text>
              <text x="505" y="185" fontSize="11" fill="#ef4444" fontWeight="bold" textAnchor="middle" data-id="element-374">
                ⬇ Antojo
              </text>

              <text x="80" y="195" fontSize="10" fill="#6b7280" textAnchor="middle" data-id="element-375">
                Desayuno
              </text>
              <text x="230" y="195" fontSize="10" fill="#6b7280" textAnchor="middle" data-id="element-376">
                Almuerzo
              </text>
              <text x="420" y="195" fontSize="10" fill="#6b7280" textAnchor="middle" data-id="element-377">
                Merienda
              </text>
              <text x="550" y="195" fontSize="10" fill="#6b7280" textAnchor="middle" data-id="element-378">
                Noche
              </text>
            </svg>
            <div className="flex items-center justify-center gap-6 mt-4 text-sm" data-id="element-379">
              <div className="flex items-center gap-2" data-id="element-380">
                <div className="w-8 h-1 bg-red-500 rounded" data-id="element-381"></div>
                <span className="text-gray-600" data-id="element-382">Sin la Secuencia de Oro</span>
              </div>
            </div>
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-383">
            <p data-id="element-384">
              Ese pico masivo es seguido rápidamente por una caída en picada, un
              desplome brusco de tu energía.
            </p>
            <p data-id="element-385">
              Esa caída es la que dispara las alarmas de emergencia en tu
              cerebro, exigiéndote azúcar urgente para sobrevivir.
            </p>
            <p data-id="element-386">
              Es pura supervivencia biológica. Tu cuerpo entra en pánico y te
              obliga a buscar comida rápida.
            </p>
            <p data-id="element-387">
              No puedes luchar contra tu biología usando solo fuerza de
              voluntad. Es una batalla perdida desde el principio.
            </p>
            <p className="font-bold text-green-700 mt-8" data-id="element-388">
              La buena noticia es que puedes detener esta montaña rusa hoy
              mismo, sin dejar de comer.
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>;
}